module.exports = __webpack_public_path__ + "img/map.ead96562.svg";